export default __webpack_public_path__ + "static/media/landing.426c645c.png";